/**
 * The manners every "Escape closes this view" shares: it has to be a fresh Escape (not a held-down repeat), nobody may have claimed it
 * already (a popup that handled it calls preventDefault in a document listener, which runs before a window one), and it must not be
 * meant for a text field the user is typing in.
 */
export function isFreshEscape(e: KeyboardEvent): boolean {
  if (e.key !== "Escape" || e.defaultPrevented || e.repeat) return false;
  const t = e.target as HTMLElement | null;
  if (!t || typeof t.tagName !== "string") return true;
  if (/^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName)) return false;
  if (t.isContentEditable || !!t.closest?.("[contenteditable=\"\"], [contenteditable=\"true\"]")) return false;
  return true;
}
